const mutations = {
    ORDER_LOADING: (state) => {
        state.orderStatus = 'loading';
    },
    ORDER_SUCCESS: (state, data) => {
        state.orderStatus = 'success';
        // state.orders = data.orders;
        Vue.set(state, 'orders', data.orders);
        // state.ordersCount = data.orders_count;
        Vue.set(state, 'ordersCount', data.orders_count);
    },
    PAYMENT_SUCCESS: (state, data) => {
        state.orderStatus = 'success';
        Vue.set(state, 'payments', data.payments);
        Vue.set(state, 'paymentsCount', data.payments_count);
    },
    ORDER_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.orderStatus = 'error';
        state.orderErrors.record(errors);
    },
    ORDER_SENT_SUCCESS: (state) => {
        state.orderStatus = '';
    },
    ORDER_SENT_ERROR: (state) => {
        state.orderStatus = 'error';
    },
    CLEAR_ORDER_ERRORS: (state) => {
        state.orderStatus = '';
        state.orderErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
